module.exports = __webpack_public_path__ + "img/08-img.34e01240.jpg";